import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Arabic } from './ar';
import { English } from './en';
import $ from "jquery";
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class langHelper {

  public currentLang: any; // Language Code

  constructor(private router: Router,private translate:TranslateService) {
    if (localStorage.getItem("Language") === null) {
      //Set language
      localStorage.setItem("Language", "en")
      this.currentLang = 'en'
    }
    else {
      this.currentLang = localStorage.getItem("Language")
      if(this.currentLang =='ar')
      this.addRTL()
    else
       this.removeRTL()
    }
  }

  ngOnInit() {
  }


  // Set translation variables
  initializeMode() {
     if(this.currentLang != null)
     {
        if(this.currentLang == 'en')
        {
          return English
        }
        else
        {
          return Arabic
        }
     }
     else
     {

      this.currentLang = 'en'

      return English

     }

  }

  switchLanguage() {
    this.currentLang == "en" ? this.currentLang = "ar" : this.currentLang = "en"
    this.translate.use(this.currentLang );
    if(this.currentLang =='ar')
      this.addRTL()
    else
       this.removeRTL()

    window.location.reload();
    localStorage.setItem('Language', this.currentLang);

    console.log("Language Changed !" , this.translate.currentLang);
  }

  addRTL(){
    $('body')?.addClass('rtl');
    $('.main-body')?.addClass('rtl');
    $('body')?.removeClass('ltr');
    $('.main-body')?.removeClass('ltr');
    $("head link#style").attr("href", $(this));
    (document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.rtl.css"));
  }

  removeRTL(){
    $('body')?.removeClass('rtl');
    $('.main-body')?.removeClass('rtl');
    $("head link#style").attr("href", $(this));
    (document.getElementById("style")?.setAttribute("href", "./assets/bootstrap/bootstrap.css"));
  }
}
